export class ComponentContainer {
    keyName: string;
    component: any;
    applicationModuleId: number;
    rootModuleId: number;
    childModuleName: string;
    isPopup?: boolean;
    accessItem: string;
    pageName: string;
    anonymous?: boolean
}
